export default {
  title: "已购入的",
  orderPrice: "订单金额",
  orderCode: "订单编号",
  orderCreateTime: "购买时间",
  orderStatus: "订单状态",
  orderPayWay: "支付方式",
  orderPayStatus: "订单状态",
  orderStatus1: "处理中",
  orderStatus2: "交易成功",
  orderStatus3: "已退款",
  orderStatus4: "退款中",
  orderStatus5: "待审核",
  orderStatus6: "已付款",
  orderStatus7: "已拒绝",
  orderUploadButtonText: "下载数据",
  orderSeaButtonText: "查看文件",
  orderRefundButtonText: "退款",
  details: {
    alertTitle: "数据描述与实际内容不符？",
    alertButtonText: "点击此处申请平台介入",
    feedbackAlertTitle:
      '<strong style="color: #000000;">点击提交</strong>意味着授权典枢平台查看您此次订单的内容及所购买的数据。',
    orderDetails: "订单详情",
    dataDetails: "交付数据详情",
  },
  buyAmount: "购买金额",
  buyNum: "购买次数",
  orderType: "交付方式",
  usage: "调用情况",
  userGuidance: "使用指南",
};
